import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import EveServerManager from './component'
import { getAttributes, getTokenServices } from '../../../../imports'
import { setServers, setEnabledServers, getLocale } from '../../../../data'

function mapStateToProps(state) {
    const locale = getLocale(state)
    return {
        serviceDomains: getAttributes(locale).serviceDomains,
        tokenServices: getTokenServices(locale),
        isChina: locale === 'zh',
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setServers, setEnabledServers }, dispatch)
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EveServerManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/EveServerManager/index.js